module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_DON_1053_SpaJan.f14eb03c.jpg";